<mat-form-field>
    <mat-label>{{label}}</mat-label>
    <mat-select [(value)]="value" (selectionChange)="onSelectionChange($event)">
        @for (item of data; track $index) {
            <mat-option [value]="item.key">{{item.value}}</mat-option>
        }
    </mat-select>
</mat-form-field>
